export default {"src":"/_next/static/media/pharmacy-order-one.04d65e15.svg","height":362,"width":358,"blurWidth":0,"blurHeight":0};